import { useState, useEffect } from 'react';
import { fetchTenderAccess } from '@/api/requests/tenderAccess';
import { useAccount } from '@/hooks/useAccount';
import { SubscriptionTier } from '@/actions/dtos/subscription';
import { useAuthenticated } from './useAuthenticated';

export const useHasTenderAccess = (tenderId?: string) => {
  const [isLoading, setIsLoading] = useState(true);
  const [tenderAccess, setTenderAccess] = useState<any>();
  const [hasAccessPermission, setHasAccessPermission] = useState(false);
  const { isAuthenticated, isLoading: isAuthLoading } = useAuthenticated();
  const { usage, currentTier, loading: accountLoading } = useAccount();

  useEffect(() => {
    setIsLoading(true);
    if (isAuthLoading) return;
    if (!isAuthenticated) {
      setIsLoading(false);
      return;
    }
    if (accountLoading || !tenderId || !usage || !currentTier) return;

    const getTenderAccess = async () => {
      try {
        setIsLoading(true);
        const tenderAccess = await fetchTenderAccess(tenderId);
        setTenderAccess(tenderAccess);
        if (
          currentTier === SubscriptionTier.PROFESSIONAL ||
          currentTier === SubscriptionTier.ULTIMATE ||
          usage.TENDER_ACCESS <= 0 ||
          !!tenderAccess
        ) {
          setHasAccessPermission(true);
        }
      } finally {
        setIsLoading(false);
      }
    };

    getTenderAccess();
  }, [isAuthenticated, tenderId, usage, currentTier, accountLoading, isAuthLoading]);

  return {
    tenderAccess,
    hasAccessPermission,
    isLoading,
  };
};
